import { InactivityWarningDialogComponent } from 'common/components';
import { useInactivityLogout } from 'core/auth/use-inactivity-logout.hook';

export const InactivityLogoutContainer: React.FC = () => {
  const { isWarningVisible, secondsLeft, staySignedIn, signOutNow } = useInactivityLogout();

  return (
    <InactivityWarningDialogComponent
      open={isWarningVisible}
      secondsLeft={secondsLeft}
      onCancel={staySignedIn}
      onLogout={signOutNow}
    />
  );
};
